var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.585786 0.752443C0.960859 0.37737 1.46957 0.166656 2 0.166656H6.66667C6.84348 0.166656 7.01305 0.236894 7.13807 0.361919L11.8047 5.02859C11.9298 5.15361 12 5.32318 12 5.49999V12.8333C12 13.3638 11.7893 13.8725 11.4142 14.2475C11.0391 14.6226 10.5304 14.8333 10 14.8333H2C1.46957 14.8333 0.960859 14.6226 0.585786 14.2475C0.210714 13.8725 0 13.3638 0 12.8333V2.16666C0 1.63622 0.210714 1.12752 0.585786 0.752443ZM2 1.49999C1.82319 1.49999 1.65362 1.57023 1.5286 1.69525C1.40357 1.82028 1.33333 1.98985 1.33333 2.16666V12.8333C1.33333 13.0101 1.40357 13.1797 1.5286 13.3047C1.65362 13.4298 1.82319 13.5 2 13.5H10C10.1768 13.5 10.3464 13.4298 10.4714 13.3047C10.5964 13.1797 10.6667 13.0101 10.6667 12.8333V5.77613L6.39052 1.49999H2Z",
    fill: "#7C8694"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 0.166656C7.03486 0.166656 7.33333 0.465133 7.33333 0.833323V4.83332H11.3333C11.7015 4.83332 12 5.1318 12 5.49999C12 5.86818 11.7015 6.16666 11.3333 6.16666H6.66667C6.29848 6.16666 6 5.86818 6 5.49999V0.833323C6 0.465133 6.29848 0.166656 6.66667 0.166656Z",
    fill: "#7C8694"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.26515344df74cd58466ef2d0eff5535a.svg";
export { ForwardRef as ReactComponent };